import { render } from "./LoadingIcon.vue?vue&type=template&id=03aee446&ts=true"
import script from "./LoadingIcon.vue?vue&type=script&lang=ts"
export * from "./LoadingIcon.vue?vue&type=script&lang=ts"

import "./LoadingIcon.vue?vue&type=style&index=0&id=03aee446&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__